import AUPPSRForm from "modules/new-applications/components/application-actions/PPSRRegister/PPSRForm/AUPPSRForm";
import NZPPSRForm from "modules/new-applications/components/application-actions/PPSRRegister/PPSRForm/NZPPSRForm";

export { NZPPSRForm };
export { AUPPSRForm };
